import type { WebCurrency } from '@lc/contracts';
import type { Lang } from './i18n';

/** A Stripe amount (minor units) as a price, without ".00" when it is whole: HK$38, A$18.99. */
export function formatPrice(amount: number, currency: WebCurrency, lang: Lang): string {
  const value = amount / 100;
  const whole = Number.isInteger(value);
  return new Intl.NumberFormat(lang === 'en' ? 'en' : 'zh-HK', { style: 'currency', currency: currency.toUpperCase(), minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(value);
}

/** A date in the site's language; `short` drops the year (10月6日, 6 Oct). */
export const formatDate = (iso: string, lang: Lang, short = false) =>
  new Intl.DateTimeFormat(lang === 'en' ? 'en-AU' : 'zh-HK', { ...(short ? {} : { year: 'numeric' }), month: lang === 'en' ? 'short' : 'long', day: 'numeric' }).format(new Date(iso));

/** Currency names for the selector. */
export const CURRENCY_LABEL: Record<WebCurrency, { zh: string; en: string }> = {
  hkd: { zh: '港元 HKD', en: 'HKD — Hong Kong dollar' },
  twd: { zh: '新台幣 TWD', en: 'TWD — New Taiwan dollar' },
  aud: { zh: '澳元 AUD', en: 'AUD — Australian dollar' },
  nzd: { zh: '紐西蘭元 NZD', en: 'NZD — New Zealand dollar' },
  sgd: { zh: '新加坡元 SGD', en: 'SGD — Singapore dollar' },
  myr: { zh: '馬來西亞令吉 MYR', en: 'MYR — Malaysian ringgit' },
  mop: { zh: '澳門元 MOP', en: 'MOP — Macanese pataca' },
  cny: { zh: '人民幣 CNY', en: 'CNY — Chinese yuan' },
  usd: { zh: '美元 USD', en: 'USD — US dollar' },
};
